import React from 'react';
// The App component's contents are currently a placeholder — please update this file first for a new design / component!
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <LandingPage data-id="element-0" />;
}